export default "__VITE_ASSET__16c373e6__"